import { Component, OnInit } from '@angular/core';
import { RouteValidationService } from "../../../../shared/route-validation.service";

@Component({
  selector: 'camtl-maintenance',
  host: { 'class': 'router-outlet' },
  templateUrl: './maintenance.component.html',
  // styleUrls: ['./maintenance.component.scss']
})
export class CamtlMaintenanceComponent implements OnInit {
  selected: string = 'default';

  constructor(public routerValidationService: RouteValidationService) { }

  ngOnInit() {
    this.routerValidationService.selected$
      .subscribe(s => this.selected = s);
    this.routerValidationService.get();
  }

}
